import {optionsToString, stringToOption} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";

export const pipelineStringToOptions = (inputPipeline) => {
    const pipeline = cloneDeep(inputPipeline)
    pipeline.interactive_channel = stringToOption(pipeline.interactive_channel, false)
    pipeline.ctv_status = stringToOption(pipeline.ctv_status, false)
    pipeline.process_info_from_ctv = stringToOption(pipeline.process_info_from_ctv, false)
    pipeline.refer_status = stringToOption(pipeline.refer_status, false)
    pipeline.refer_info_process = stringToOption(pipeline.refer_info_process, false)
    pipeline.cdd_status = stringToOption(pipeline.cdd_status)
    pipeline.user_qualify_uv = stringToOption(pipeline.user_qualify_uv)
    pipeline.todo_with_person = stringToOption(pipeline.todo_with_person)
    pipeline.internal_process = stringToOption(pipeline.internal_process, false)
    pipeline.cdd_to_employer_process = stringToOption(pipeline.cdd_to_employer_process, false)
    pipeline.payment_and_warranty = stringToOption(pipeline.payment_and_warranty, false)
    pipeline.job_service_type = stringToOption(pipeline.job_service_type, false)
    // pipeline.created_user = stringToOption(pipeline.created_user ? pipeline.created_user.toString() : "", false)
    return pipeline
}

export const pipelineOptionsToString = (jobPipeline) => {
    const body = {...jobPipeline}
    body.interactive_channel = optionsToString(jobPipeline.interactive_channel, false)
    body.ctv_status = optionsToString(jobPipeline.ctv_status, false)
    body.process_info_from_ctv = optionsToString(jobPipeline.process_info_from_ctv, false)
    body.refer_status = optionsToString(jobPipeline.refer_status, false)
    body.refer_info_process = optionsToString(jobPipeline.refer_info_process, false)
    body.cdd_status = optionsToString(jobPipeline.cdd_status)
    body.user_qualify_uv = optionsToString(jobPipeline.user_qualify_uv)
    body.todo_with_person = optionsToString(jobPipeline.todo_with_person)
    body.internal_process = optionsToString(jobPipeline.internal_process, false)
    body.cdd_to_employer_process = optionsToString(jobPipeline.cdd_to_employer_process, false)
    body.payment_and_warranty = optionsToString(jobPipeline.payment_and_warranty, false)
    body.job_service_type = optionsToString(jobPipeline.job_service_type, false)
    // body.created_user = optionsToString(jobPipeline.created_user, false)

    return body
}
